module.exports = __webpack_public_path__ + "img/stock1.cc58a34d.png";